import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';

@Component({
  selector: 'app-cancel-work-order-success-page',
  templateUrl: './cancel-work-order-success.page.html',
  styleUrls: ['./cancel-work-order-success.page.scss']
})
export class CancelWorkOrderSuccessPage implements OnInit {

  workOrderNumber: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: GtrakAuthService
  ) { }

  ngOnInit(): void {
    this.workOrderNumber = this.route.snapshot.paramMap.get('workOrderNumber');
  }

  goToMainScreen(): void {
    this.router.navigate([this.authService.user?.homeLocation || '/garment-listing']);
  }
}
